import { createAction, props } from "@ngrx/store";
import { PaginationRequest } from "src/app/models/common/paginationRequest";

export const resetProductGroupState = createAction(
  "[ProductGroup] Reset Product Group State Action"
);
export const resetProductGroupsState = createAction(
  "[ProductGroup] Reset Product Groups Action"
);
export const resetCreation = createAction("[ProductGroup] Reset Creation Action");
export const getProductGroupList = createAction(
  "[ProductGroup] Get All Product Groups List Action",
  props<{ options: any }>()
);
export const loadProductGroupList = createAction(
  "[ProductGroup] Load All Product Groups List Action",
  props<{ response: any[] }>()
);

export const getExcelProductGroupList = createAction(
  "[ProductGroup] Get Excel All Product Groups List Action",
  props<{ options: any }>()
);
export const loadExcelProductGroupList = createAction(
  "[ProductGroup] Load Excel All Product Groups List Action",
  props<{ response: any[] }>()
);

// Table Configuration Settings
export const getProductGroupTableConfig = createAction(
  "[ProductGroup] Get Product Groups Table Configuration Action",
  props<{ options: any }>()
);
export const loadProductGroupTableConfig = createAction(
  "[ProductGroup] Load Product Groups Table Configuration Action",
  props<{ response: any[] }>()
);
export const saveProductGroupTableConfig = createAction(
  "[ProductGroup] Save Product Groups Table Configuration Action",
  props<{ config: any }>()
);

export const createProductGroup = createAction(
  "[ProductGroup] Create Product Group Action",
  props<{ productGroup: any }>()
);
export const updateProductGroup = createAction(
  "[Products] Update Product Group Action",
  props<{ productGroup: any }>()
);
export const getProductGroup = createAction(
  "[ProductGroup] Get Product Action",
  props<{ code: string }>()
);
export const loadProductGroup = createAction(
  "[ProductGroup] Load ProductGroup Action",
  props<{ response: any }>()
);
export const getCategoriesByUsage = createAction(
  "[ProductGroup] Get All Categories by Usage Action",
  props<{ pageReq: PaginationRequest; usageCode: string }>()
);
export const loadCategoriesByUsage = createAction(
  "[ProductGroup] Load All Categories by Usage Action",
  props<{ response: any[] }>()
);
export const getPropertiesByUsage = createAction(
  "[ProductGroup] Get All Properties by Usage Action",
  props<{ pageReq: PaginationRequest; usageCode: string }>()
);
export const loadPropertiesByUsage = createAction(
  "[ProductGroup] Load All Properties by Usage Action",
  props<{ response: any[] }>()
);

export const setLoadingStartState = createAction(
  "[ProductGroup] Set Product Groups Loading Start State Action"
);
export const setLoadingEndState = createAction(
  "[ProductGroup] Set Product Groups Loading End State Action"
);
